// https://www.i18next.com/translation-function/plurals
// https://github.com/eemeli/intl-pluralrules
import 'intl-pluralrules';
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/300-italic.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/400-italic.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/600-italic.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/700-italic.css';
import '@fontsource/open-sans/800.css';
import '@fontsource/open-sans/800-italic.css';
import '@fontsource/dancing-script/600.css';
import './utils/log';
import './styles/css/index.scss';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';

// attach React to the window object, in case it's not already present
window.React ??= React;

// support advanced formats https://day.js.org/docs/en/plugin/advanced-format
dayjs.extend(advancedFormat);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element with id "root" was not found in the DOM');
}

createRoot(container).render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
